export const firebaseConfig = {
  apiKey: "AIzaSyABEoAw4dmprbH0sG7kfu3_A70ZsdpCnTk",
  authDomain: "chien-tete-en-bas.firebaseapp.com",
  projectId: "chien-tete-en-bas",
  storageBucket: "chien-tete-en-bas.appspot.com",
  messagingSenderId: "169376465737",
  appId: "1:169376465737:web:f2659a9fd1d569a99d9098",
  measurementId: "G-PH87PQFRYK",
};
